import(/* webpackMode: "eager", webpackExports: ["Nav"] */ "/Users/k1dalica/Desktop/Projects/infiteq.io/components/layout/nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k1dalica/Desktop/Projects/infiteq.io/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k1dalica/Desktop/Projects/infiteq.io/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/Users/k1dalica/Desktop/Projects/infiteq.io/node_modules/next/dist/client/image-component.js");
